import { passwordValidation } from "@/pages/company/schema";
import z from "zod";

const CreateUserSchema = z.object({
  role: z.string().optional(),
  full_name: z
    .string()
    .trim()
    .min(1, "ユーザー名を入力してください。")
    .max(255, "ユーザー名は225文字以下で入力してください。"),
  company_name: z
    .string()
    .trim()
    .max(255, "会社名は255文字以下で入力してください。")
    .optional(),
  position: z
    .string()
    .trim()
    .max(255, "役職は255文字以下で入力してください。")
    .optional(),
  department: z
    .string()
    .trim()
    .max(255, "部署は255文字以下で入力してください。")
    .optional(),
  email: z
    .string()
    .trim()
    .min(1, "メールアドレスを入力してください。")
    .refine((val) => z.email().safeParse(val).success, {
      message: "メールアドレスは無効な形式です。",
    })
    .max(255, "メールアドレス/パスワードは半角255文字以下で入力してください。"),
  password: passwordValidation,
});

export { CreateUserSchema };
